import { IonInfiniteScroll, IonPage } from '@ionic/react'
import { AnimatePresence, motion, Variants } from 'framer-motion'

import { useMyMonitoringGetNotifications } from '@apps-common/apis/my-monitoring/notifications'
import { InfiniteLoader, PullRefresh } from '@apps-common/components/common'
import { PageTitle } from '@apps-common/components/common/portal-title'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { VertSpacerXl } from '@apps-common/components/layout/spacers'
import { NotificationCard } from '@apps-common/components/modals/notifications'
import { Navbar } from '@apps-common/components/navigation'
import { useLastViewedNotificationStore } from '@apps-common/stores'
import { INotificationLogModel } from '@apps-common/types/portal/notification'

const variants: Variants = {
  initial: {
    opacity: 0,
    transition: {
      duration: 0.05
    }
  },
  animate: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
      duration: 0.05
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.05
    }
  }
}

export const Notifications = () => {
  const { lastId } = useLastViewedNotificationStore()

  const { isLoading, isError, isFetching, data, refetch, fetchNextPage } = useMyMonitoringGetNotifications({
    take: 20
  })

  const loading = !data || isLoading || isError

  return (
    <IonPage>
      <Navbar transparent />
      <LayoutContainer>
        <PullRefresh loading={loading} callback={refetch} />
        <LayoutPadding>
          <PageTitle>
            <span>Notifications</span>
          </PageTitle>
          <VertSpacerXl />

          {!loading && (
            <AnimatePresence>
              <motion.div
                variants={variants}
                initial='initial'
                animate='animate'
                className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 gap-4 sm:gap-4'
              >
                {data?.pages
                  .reduce((acc: INotificationLogModel[], curr: INotificationLogModel[]) => [...acc, ...curr], [])
                  .map((n) => (
                    <NotificationCard key={`notification-list-${n.id}`} model={n} lastViewedId={lastId} />
                  ))}
              </motion.div>
            </AnimatePresence>
          )}

          <IonInfiniteScroll
            onIonInfinite={async (ev) => {
              await fetchNextPage()
              ev.target.complete()
            }}
          >
            <InfiniteLoader key='notifications-list-infinite-loader' loading={isFetching} />
          </IonInfiniteScroll>
        </LayoutPadding>
        <VertSpacerXl />
      </LayoutContainer>
    </IonPage>
  )
}
